/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch } from 'react-redux';
import { useContext, useEffect } from 'react';
import { URLS } from '../../../../constants/urls.constants';
import { setAlert } from '../../../../store/modules/snackbar';
import { useApiRequest } from '../../../../hooks/useApiRequest';
import { stopLoading } from '../../../../store/modules/loading';
import { SupervisionProjectContext } from '../../contexts/useSupervisionProjectContext';
import { IUpdateFindings } from '../interfaces/update-finding.interface';

export function useUpdateFindings() {
	const dispatch = useDispatch();
	const { undoState } = useContext(SupervisionProjectContext);

	const { execute: executeUpdateFindings, status: statusUpdateFindings } =
		useApiRequest<IUpdateFindings, unknown>({
			path: URLS.SUPERVISION_ROUTINE.UPDATE_FINDINGS,
			method: 'PATCH',
		});

	useEffect(() => {
		if (statusUpdateFindings === 'success') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Incidencia modificada con éxito.',
					severity: 'success',
				})
			);
			undoState();
		} else if (statusUpdateFindings === 'error') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Ha ocurrido un error, intente de nuevo.',
					severity: 'error',
				})
			);
		}
	}, [statusUpdateFindings]);

	return {
		executeUpdateFindings,
	};
}
